var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Workload_analysis"},[_c('div',{ref:"myechart",staticStyle:{"width":"500px","height":"500px","margin-left":"3%"},attrs:{"id":"main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }